import enMessages from '../../../messages/en.json';
import zhMessages from '../../../messages/zh.json';
import type { SeoGuideArticle, SeoGuideLocale } from './guides';
import { guideVisual, type SeoGuideVisualAssetKey } from './guide-visuals';

const jacketAssets: SeoGuideVisualAssetKey[] = ['referenceProductSource', 'referenceStyleJacketFirst', 'referenceStyleJacketRevised'];
const reuseAssets: SeoGuideVisualAssetKey[] = ['fashionModelGarmentSource', 'referenceStyleTrench'];

/** 现有参考图教程补充当前 Style 工作流，保留原 URL 和教程内容。 */
export function withReferenceStyleWorkflow(guide: SeoGuideArticle, locale: SeoGuideLocale): SeoGuideArticle {
  if (guide.slug !== 'reference-image-ai-generation-workflow') return guide;
  const copy = (locale === 'zh' ? zhMessages : enMessages).seoGuides.referenceStyleWorkflow;
  const params = new URLSearchParams({ lang: locale, source_landing: guide.path });
  const startHref = `/explore?${params.toString()}`;
  const caseSection = {
    ...copy.case,
    visuals: jacketAssets.map((key, index) => guideVisual(key, copy.case.visuals[index].alt, copy.case.visuals[index].caption)),
  };
  const reuseSection = {
    ...copy.reuse,
    visuals: reuseAssets.map((key, index) => guideVisual(key, copy.reuse.visuals[index].alt, copy.reuse.visuals[index].caption)),
  };
  return {
    ...guide,
    modifiedDate: '2026-09-14',
    startHref,
    images: [...new Set([guide.heroImage, ...caseSection.visuals.map(v => v.src), ...reuseSection.visuals.map(v => v.src)])],
    sections: [
      guide.sections[0],
      copy.selection,
      copy.review,
      { ...copy.workflow, links: [{ label: copy.ctaLabel, href: startHref }] },
      caseSection,
      reuseSection,
      ...guide.sections.slice(1),
    ],
    ctaTitle: copy.ctaTitle,
    ctaBody: copy.ctaBody,
    ctaLabel: copy.ctaLabel,
  };
}
